export enum CrashGameType {
  Classic = 'classic',
  Trenball = 'trenball',
}
